import { render, staticRenderFns } from "./ParentAssessmentTerms.vue?vue&type=template&id=6923a5d8&scoped=true&"
import script from "./ParentAssessmentTerms.vue?vue&type=script&lang=js&"
export * from "./ParentAssessmentTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6923a5d8",
  null
  
)

export default component.exports